import psl_ui from '../../libs/psl_ui.js';

import template from './template.pst';

import {wait} from '../../libs/psl_polyfills.js';

import './style.scss';

psl_ui.templates.add('component_steps',template);

const {el,rpoints}=psl_ui.templates.render('component_steps');

rpoints.btn.addEventListener('click',()=>{
	if(!_btn_clb) return;
	_btn_clb();
});

const _render = ({btn,steps})=>{
	_render_btn(btn);
	_render_steps(steps);
}

let _btn_clb;

const _render_btn = ({clb,cls,label,hidden})=>{
	rpoints.btn.innerHTML=label;
	rpoints.btn.className=cls;
	_btn_clb=clb;
	if(_btn_clb){
		rpoints.btn.removeAttribute('tabindex');
	} else {
		rpoints.btn.setAttribute('tabindex','-1');
		rpoints.btn.blur();
	}

	rpoints.btn[hidden?'setAttribute':'removeAttribute']('aria-hidden','true');
}

const _render_steps = (steps)=>{
	while(rpoints.steps.childNodes.length>steps.length){
		rpoints.steps.removeChild(rpoints.steps.lastChild);
	}
	while(rpoints.steps.childNodes.length<steps.length){
		const step=document.createElement('button');
		rpoints.steps.appendChild(step);
		step.addEventListener('click',()=>{
			if(step._clb) step._clb();
			step.blur();
		});
	}

	steps.forEach(({clb,cls},i)=>{
		const step = rpoints.steps.childNodes[i];
		step.className=cls;
		step.setAttribute('aria-label',`Step ${i+1}${step.classList.contains('correct')?': correct':step.classList.contains('incorrect')?': incorrect':''}`);
		step._clb=clb;
		if(clb){
			step.removeAttribute('tabindex');
			step.removeAttribute('aria-hidden');
			step.classList.add('clickable');
		} else {
			step.setAttribute('tabindex','-1');
			step.setAttribute('aria-hidden','true');
			step.classList.remove('clickable');
		}
	});
}

export default {
	view:el,
	rpoints,
	render:_render,
	render_btn:_render_btn,
	render_steps:_render_steps
};
